const config = {
    API_URL: "https://restaurant.rafalsprengel.com"
};

export default config;